<template>
  <div class="page-wrapper">
    <div class="tiles d-flex flex-row pa-2">
      <div class="tile-wrapper">
        <doughnut-chart
          title="Employees Based on Location"
          :data="Object.values(this.chartData)"
          :labels="Object.keys(this.chartData)"
        ></doughnut-chart>
      </div>
      <div class="tile-wrapper flex">
        <v-card class="mx-auto" height="280px">
          <v-card-title class="title">Skillset based on Location</v-card-title>
          <v-card-text></v-card-text>
        </v-card>
      </div>
    </div>
    <div class="actions d-flex flex-row align-center pr-2 pl-2">
      <ul class="actions-wrapper">
        <li class="action-items table-search ma-2">
          <v-text-field
            v-model="searchString"
            class="searchbar"
            hide-details
            dense
            clearable
            solo
            label="Search by Employee"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </li>
        <li class="action-items">
          <div class="text-center">
            <v-menu
              v-model="filterMenu"
              :close-on-content-click="false"
              max-width="400px"
              min-width="400px"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-btn color="white" v-on="on" class="ma-3">
                  <v-icon>mdi-filter</v-icon>filter
                </v-btn>
              </template>
              <v-card class="pb-4">
                <v-list>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Status</div>
                      <v-select
                        v-model="filters.status"
                        placeholder="Select Status"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        :items="statusList"
                      ></v-select>
                    </v-list-item-title>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Job Title</div>
                      <v-select
                        v-model="filters.jobTitle"
                        placeholder="Select Job Title"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        :items="jobTitles"
                      ></v-select>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Date</div>
                      <v-dialog
                        ref="sdDialog"
                        v-model="filterDateModal"
                        :return-value.sync="filters.createdAt"
                        persistent="false"
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="filters.createdAt"
                            placeholder="Pick a Date"
                            readonly
                            outlined
                            background-color="white"
                            dense
                            filled
                            hide-details
                            v-on="on"
                            append-icon="mdi-calendar-month"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="filters.createdAt" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="filterDateModal = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.sdDialog.save(filters.createdAt)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-list-item-title>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Project</div>
                      <v-select
                        v-model="filters.projects"
                        placeholder="Select Project"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        item-text="projectName"
                        item-value="id"
                        :items="projects"
                      ></v-select>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">User Role</div>
                      <v-select
                        v-model="filters.role"
                        placeholder="Select Role"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        :items="empRoles"
                      ></v-select>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#0e07b5" outlined @click="closeFiltersMenu"
                    >Cancel</v-btn
                  >
                  <v-btn color="#0e07b5" outlined @click="resetAppliedFilters"
                    >Reset</v-btn
                  >
                  <v-btn
                    color="#0e07b5"
                    class="mr-4 white--text"
                    @click="applyFilters"
                    >Apply</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>
        </li>
        <v-spacer></v-spacer>
        <li class="action-items">
          <v-btn
            depressed
            dark
            large
            color="#0e07b5"
            class="ma-3"
            @click="openDialog('Add New Employee')"
          >
            <v-icon>mdi-plus</v-icon>Add New Employee
          </v-btn>
        </li>
      </ul>
    </div>
    <div class="table">
      <data-table
        :fixedHeader="true"
        :headers="headers"
        :content="filteredDataArray"
        :projects="projects"
        :searchString="searchString"
        @update="updateItem"
        @delete="deleteItem"
      ></data-table>
    </div>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <div
          id="mdiv"
          @click="
            () => {
              dialog = false;
            }
          "
        >
          <div class="mdiv">
            <div class="md"></div>
          </div>
        </div>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    :rules="fieldRules"
                    label="First Name*"
                    required
                    v-model="user.firstName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    :rules="fieldRules"
                    label="Last Name*"
                    required
                    v-model="user.lastName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Job Title"
                    v-model="user.jobTitle"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    :rules="emailRules"
                    label="Email*"
                    required
                    v-model="user.email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="user.status"
                    :items="statusList"
                    label="Status *"
                    :rules="[(v) => !!v || 'Value is required']"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="user.role"
                    :items="empRoles"
                    label="User Role *"
                    :rules="[(v) => !!v || 'Value is required']"
                    required
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    label="City"
                    v-model="user.location.city"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="user.location.country"
                    :items="countryList"
                    label="Country"
                    item-text="name"
                    item-value="code"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Close</v-btn>
          <v-btn text color="error" class="mr-4" @click="reset">Reset</v-btn>
          <v-btn
            text
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="
              dialogTitle == 'Add New Employee'
                ? addEmployee()
                : updateEmployee()
            "
            >{{ dialogTitle == "Add New Employee" ? "save" : "update" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DoughnutChart from "@/components/DoughnutChart.vue";
import DataTable from "@/components/DataTable.vue";

import firebase from "../firebase";
import countryList from "../country.js";

export default {
  name: "Employees",
  components: {
    DoughnutChart,
    DataTable
  },
  data() {
    return {
      createUserBaseUrl:
        "https://us-central1-mytimetracker-93578.cloudfunctions.net/createUser",
      searchString: "",
      filterMenu: false,
      filterDateModal: false,
      filteredDataArray: [],
      filters: {
        projects: "",
        status: "",
        createdAt: "",
        jobTitle: "",
        role: ""
      },

      statusList: ["Inactive", "Active", "Left", "Joining", "Reserved"],
      countryList: countryList,
      dialogTitle: "",
      dialog: false,
      valid: true,
      fieldRules: [
        (v) => !!v || "Value is required",
        (v) => (v && v.length >= 3) || "Value must be greater than 3 characters"
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      user: {
        firstName: "",
        lastName: "",
        jobTitle: "",
        status: "",
        email: "",
        location: {
          city: "",
          country: ""
        },
        role: "",
        createdAt: 0,
        projects: {},
        updatedAt: 0
      },

      projects: [],
      projectsRef: null,
      employeesRef: null,
      empRoleRef: null,
      employees: [],
      empRoles: [],
      chartData: {},
      headers: [
        {
          name: "initials",
          label: " ",
          type: "initials"
        },
        {
          name: "name",
          label: "Name",
          type: "text"
        },
        {
          name: "projectNames",
          label: "Assigned Projects",
          type: "text"
        },
        {
          name: "utilization",
          label: "Utilization (Monthly)",
          type: "text"
        },
        {
          name: "status",
          label: "Status",
          type: "status"
        },
        {
          name: "locationString",
          label: "Location",
          type: "text"
        },
        {
          label: "Action",
          type: "action"
        }
      ],
      empWorksheets: {},
      waitingFor: 0,
      currentMonthWorkingDays: 0,
      holidays: [2, 0, 0, 0, 1, 0, 1, 0, 1, 0, 2, 1]
    };
  },
  created() {
    this.setThisMonthWorkingDays();

    let self = this;
    this.projectsRef = firebase.firestore().collection("projects");
    this.projectsRef.onSnapshot((querySnapshot) => {
      self.projects = [];
      querySnapshot.docs.forEach((doc) => {
        self.projects.push({
          id: doc.id,
          ...doc.data()
        });
        doc.ref.collection("Employees").onSnapshot((empQuerySnapshot) => {
          empQuerySnapshot.docs.forEach((empDoc) => {
            self.empWorksheets[empDoc.id] = [];
            self.waitingFor++;
            empDoc.ref
              .collection("workSheet")
              .onSnapshot((workQuerySnapShot) => {
                if (self.waitingFor == 0) self.populateFilteredDataArray();
                workQuerySnapShot.forEach((workDoc) => {
                  self.empWorksheets[empDoc.id].push(workDoc.data());
                });
                self.waitingFor--;
              });
          });
        });
      });
      self.populateFilteredDataArray();
    });

    this.employeesRef = firebase.firestore().collection("user");
    this.employeesRef.onSnapshot((querySnapshot) => {
      this.employees = [];
      querySnapshot.forEach((doc) => {
        this.employees.push({
          id: doc.id,
          ...doc.data()
        });
      });
      this.populateFilteredDataArray();
      this.populateChartData();
    });

    this.empRoleRef = firebase.firestore().collection("dropdowns");
    this.empRoleRef
      .doc("roles")
      .get()
      .then((doc) => {
        let data = doc.data();
        if (data && data.values && data.values.length > 0) {
          this.empRoles = data.values;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    jobTitles() {
      return this.employees
        .filter((emp) => emp.jobTitle)
        .map((obj) => obj.jobTitle);
    }
  },
  watch: {
    waitingFor() {
      if (this.waitingFor == 0) {
        this.populateFilteredDataArray();
      }
    }
  },
  methods: {
    populateChartData() {
      let data = new Object();
      this.employees.forEach((emp) => {
        if ("location" in emp && emp.location && "country" in emp.location) {
          let country = countryList.find(
            (obj) => obj.code == emp.location.country
          );
          if (country) {
            country = country.name;
            if (country in data) data[country] = data[country] + 1;
            else data[country] = 1;
          } else {
            if (data[emp.location.country])
              data[emp.location.country] + data[emp.location.country];
            else data[emp.location.country] = 1;
          }
        }
      });
      this.chartData = data;
    },
    addEmployee() {
      let valid = this.validate();
      if (valid) {
        this.user.email = this.user.email.toLowerCase().trim();
        this.user.createdAt = new Date().valueOf();
        this.user.projects = {};
        this.user.updatedAt = 0;
        fetch(this.createUserBaseUrl + "?email=" + this.user.email)
          .then((response) => response.json())
          .then((data) => {
            if (data.uid && data.password) {
              this.user.password = data.password;
              let id = data.uid;
              this.user.userId = id;
              this.user.id = id;
              this.user.documentId = id;
              this.employeesRef
                .doc(id)
                .set(this.user)
                .then(() => {
                  this.reset();
                });
            }
          });
        this.dialog = false;
      }
    },
    updateEmployee() {
      let valid = this.validate();
      let self = this;
      if (valid) {
        this.user.updatedAt = new Date().valueOf();
        let id = this.user.id;
        delete this.user.id;
        let tempUser = {
          userId: id,
          email: this.user.email.trim(),
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          location: this.user.location,
          role: this.user.role,
          documentId: id,
          status: this.user.status,
          createdAt: this.user.createdAt,
          updatedAt: this.user.updatedAt,
          jobTitle: this.user.jobTitle
        };
        firebase
          .firestore()
          .collection("user")
          .doc(id)
          .set(tempUser, { merge: true })
          .then(() => {
            self.reset();
          });
        this.dialog = false;
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.user = {
        firstName: "",
        lastName: "",
        jobTitle: "",
        status: "",
        email: "",
        location: {
          city: "",
          country: ""
        },
        createdAt: 0,
        projects: {},
        updatedAt: 0
      };
      this.resetValidation();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    closeDialog() {
      this.dialog = false;
      this.user = JSON.parse(JSON.stringify(this.user));
      this.reset();
    },
    openDialog(title) {
      this.dialogTitle = title;
      this.dialog = true;
    },
    updateItem(item) {
      this.dialogTitle = "Update Employee";
      let found = this.employees.find((emp) => emp.id == item.id);
      if (found) item = found;
      for (const key in this.user) {
        if (!Object.prototype.hasOwnProperty.call(item, key)) {
          item[key] = this.user[key];
        }
      }
      this.user = item;
      this.dialog = true;
    },
    deleteItem(item) {
      this.employeesRef.doc(item.id).delete();
    },

    resetAllFilters() {
      for (const key in this.filters) {
        this.filters[key] = "";
      }
    },
    closeFiltersMenu() {
      this.filterDateModal = false;
      this.filterMenu = false;
    },
    applyFilters() {
      let self = this;
      this.filterDateModal = false;
      this.filterMenu = false;
      this.filteredDataArray = this.filteredDataArray.filter((emp) => {
        let found = false;
        for (const key in self.filters) {
          const val = self.filters[key];
          if (val) {
            if (key == "createdAt") {
              let date1 = new Date(emp.createdAt);
              let date2 = new Date(val);
              if (
                date1.getFullYear() == date2.getFullYear() &&
                date1.getMonth() == date2.getMonth() &&
                date1.getDate() == date2.getDate()
              )
                found = true;
              else {
                found = false;
                break;
              }
            } else if (key == "projects") {
              found = false;
              if (key in emp && emp[key]) {
                Object.keys(emp[key]).forEach((pId) => {
                  if (pId == val) {
                    found = true;
                    return;
                  }
                });
              }
            } else if (emp[key] == val) found = true;
            else {
              found = false;
              break;
            }
          }
        }
        return found;
      });
    },
    resetAppliedFilters() {
      this.filterDateModal = false;
      this.filterMenu = false;
      this.resetAllFilters();
      this.populateFilteredDataArray();
    },
    populateFilteredDataArray() {
      this.filteredDataArray = [];
      if (this.employees.length > 0) {
        this.employees.forEach((emp) => {
          let empData = {
            id: emp.id,
            initials: this.getInitials(emp, ["firstName", "lastName"]),
            firstName: emp.firstName,
            lastName: emp.lastName,
            email: emp.email,
            name: emp.firstName + " " + emp.lastName,
            projects: emp.projects,
            projectNames: this.getEmployeeProjectNames(emp),
            utilization: this.getEmpUtilization(emp),
            status: emp.status,
            locationString: this.getLocation(emp.location),
            location: emp.location,
            createdAt: emp.createdAt,
            jobTitle: emp.jobTitle
          };
          this.filteredDataArray.push(empData);
        });
      }
    },

    getInitials(data, keyNames) {
      let val = "";
      if (keyNames instanceof Array) {
        keyNames.forEach((key) => {
          let text = data[key];
          if (text) val += text.charAt(0).toUpperCase();
        });
      } else {
        let text = data[keyNames];
        if (text) val += text.charAt(0).toUpperCase();
      }
      return val;
    },
    getEmployeeProjectNames(user) {
      let projectNames = "";
      if (user.projects && Object.keys(user.projects).length > 0) {
        Object.keys(user.projects).forEach((key) => {
          let obj = this.projects.find((project) => project.id == key);
          if (obj) {
            projectNames += obj.projectName + ", ";
          }
        });
        projectNames = projectNames.trim();
        projectNames = projectNames.substring(0, projectNames.length - 1);
      }
      return projectNames;
    },
    getLocation(location) {
      let val = "";
      if (location && Object.keys(location).length > 0) {
        val = location.city;
        if ("country" in location) {
          if (val) val += ", " + location.country;
          else val = location.country;
        }
      }
      return val;
    },
    getEmpUtilization(emp) {
      let workedHrs = 0;
      if (
        emp.id in this.empWorksheets &&
        this.empWorksheets[emp.id].length > 0
      ) {
        let docs = this.empWorksheets[emp.id].filter((doc) => {
          if (
            new Date().getMonth() == new Date(doc.startAt).getMonth() ||
            new Date().getMonth() == new Date(doc.endAt).getMonth()
          )
            return true;
          else return false;
        });
        if (docs && docs.length > 0) {
          docs.forEach((doc) => {
            workedHrs += doc.totalHours;
          });
        }
      }
      if (this.currentMonthWorkingDays == 0) this.setThisMonthWorkingDays();
      let workedHrsPercentage =
        (workedHrs / this.currentMonthWorkingDays) * 100;
      if (workedHrsPercentage && workedHrsPercentage.toString().includes(".")) {
        workedHrsPercentage = workedHrsPercentage.toFixed(2);
      }
      return workedHrsPercentage + "%";
    },
    setThisMonthWorkingDays() {
      this.currentMonthWorkingDays = 0;
      let d = new Date();
      let days = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
      for (let i = 1; i <= days; i++) {
        let day = new Date(d.getFullYear(), d.getMonth(), i).getDay();
        if (day != 0 && day != 6) {
          this.currentMonthWorkingDays += 8;
        }
      }
      this.currentMonthWorkingDays =
        this.currentMonthWorkingDays - this.holidays[d.getMonth()];
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  padding: 1vh 1vw;
}
.tiles {
  padding: 10px 0px;
  align-items: center;
  flex-wrap: wrap;
  min-height: 300px;
  height: auto;
}

.tile-wrapper {
  height: 100%;
  margin: 10px;
}

.actions-wrapper {
  width: 100%;
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px;
  padding: 0px;
  flex-wrap: wrap;
}

.table-search {
  width: 100%;
  min-width: 200px;
  max-width: 600px;
}

#mdiv {
  margin: 10px;
  width: 25px;
  height: 25px;
  float: right;
  /* background-color: red; */
  /* border: 1px solid black; */
}

.mdiv {
  height: 25px;
  width: 2px;
  margin-left: 12px;
  background-color: grey;
  transform: rotate(45deg);
  z-index: 1;
}

.md {
  height: 25px;
  width: 2px;
  background-color: grey;
  transform: rotate(90deg);
  z-index: 2;
}
</style>
